// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1256":"dfae83c191cca315","4373":"408dfe0f43e0e340","4641":"efd09117fcff3c90","5845":"a6edc9e08ec1ff32","9812":"33954f5c791d5c63"}[chunkId] + ".js";
};